import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  title: string,
 *  body: string,
 *  publish: boolean,
 *  creationDate: string,
 *  updateDate: string,
 *  updatedBy: number }} Announcement
 */

const api = new Api("api/announcements");

/**
 * @returns {Promise<AxiosResponse<Announcement[]>>}
 */
export const getPublished = () =>
  api.get("published", {}, { withCredentials: false });

/**
 * @returns {Promise<AxiosResponse<Announcement[]>>}
 */
export const getAll = () => api.get();

/**
 * @param {number} id
 * @returns {Promise<AxiosResponse<Announcement>>}
 */
export const getById = (id) => api.get(id);

export const create = (payload) => api.post("", payload);

export const update = (id, payload) => api.putId(id, payload);

export const remove = (id) => api.del(id);
